import { render, staticRenderFns } from "./AccessManagement.vue?vue&type=template&id=95774c82&scoped=true&"
import script from "./AccessManagement.vue?vue&type=script&lang=js&"
export * from "./AccessManagement.vue?vue&type=script&lang=js&"
import style0 from "./AccessManagement.vue?vue&type=style&index=0&id=95774c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95774c82",
  null
  
)

export default component.exports